<template>
    <div ref="label" @click="openFilters" class="clickable root noselect" style="min-width: 70px;">
        <div class="d-inline-flex align-content-center label-wrapper">
            <div class="caption muted mb-0 secondary-color" style="align-self: end;">
                {{ label }}
            </div>
            <b-badge
                v-if="count"
                class="secondary-color light-gray lighten-background align-self-center ml-1"
                >{{ count }}</b-badge
            >
            <BaseIcon class="secondary-color" name="caret-down" size="xs" />
        </div>
        <div id="filters" v-if="showFilters" class="filter-wrapper" v-on-clickaway="closeFilters">
            <h6
                v-for="(option, i) in options"
                :key="option.label + i"
                :class="[
                    'filter-item',
                    'text-center',
                    'p-3',
                    'h-100',
                    'clickable',
                    'mb-0',
                    'noselect',
                    isSelected(option) ? 'secondary darken-on-hover selected' : '',
                ]"
                @click="toggleFilter(option)"
            >
                {{ option.label }}
            </h6>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import Vue from 'vue';
export default {
    mixins: [clickaway],
    name: 'FilterBuilder',
    props: {
        label: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        settings: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: Object,
            default: () => ({}),
        },
        maxHeight: {
            type: Number,
            default: 300,
        },
        yOffset: {
            type: Number,
            default: undefined,
        },
    },
    data() {
        return {
            showFilters: false,
        };
    },
    methods: {
        openFilters() {
            // Toggle show
            this.showFilters = true;
        },
        closeFilters(event) {
            this.showFilters = false;
        },
        toggleFilter(option) {
            if (this.value) {
                if (
                    this.value[option.key] instanceof Object &&
                    this.value[option.key][option.value]
                ) {
                    delete this.value[option.key][option.value];
                    this.emit({ ...this.value });
                } else {
                    if (this.count != this.settings.limit) {
                        if (!(this.value[option.key] instanceof Object)) {
                            this.value[option.key] = {};
                        }
                        this.value[option.key][option.value] = 1;
                        this.emit({ ...this.value });
                    } else {
                        this.$interfaces.messageModule.addNewMessage({
                            title: this.$t('shared.searchModule.filterLimit.title'),
                            message: this.$t('shared.searchModule.filterLimit.message'),
                        });
                    }
                }
            }
            this.$forceUpdate();
        },
        isSelected(option) {
            if (this.value) {
                return Boolean(this.value[option.key] && this.value[option.key][option.value]);
            } else {
                return {};
            }
        },

        emit(val) {
            this.$emit('update:filter', val);
        },
    },
    computed: {
        count() {
            return Object.keys(
                this.options.reduce((acc, option) => ({ ...acc, [option.key]: true }), {})
            ).reduce((acc, key) => Object.keys(this.value[key] || {}).length + acc, 0);
        },
    },
};
</script>

<style scoped>
.root {
    position: relative;
}
#filters {
    position: absolute;
    z-index: 999;
    display: flex;
    flex-direction: column;
    background-color: white;

    min-width: calc(100% + 100px);

    overflow-y: auto;
}

.selected {
    color: white !important;
    background-color: var(--secondary) !important;
}

.filter-wrapper {
    max-height: 262px;
    border: 1px solid #eee;
}

.filter-item {
    border-bottom: 1px solid #eee;
}

.label-wrapper {
    margin-left: 10px;
    margin-right: 10px;
}

@media only screen and (max-width: 1000px) {
    #filters {
        min-width: 100%;
        position: unset;
        margin-top: 10px;
    }
}

#filters * {
    white-space: nowrap;
}
</style>
